module.exports = [
  {
    key: 'wallet_management',
    name: '월렛 관리',
    multilevel: true,
    icon: 'walletManagement',
    child: [
      {
        key: 'dashboard',
        name: '대시보드',
        link: '/admin/wallet/dashboard'
      },
      {
        // key: 'token_nft_management',
        key: 'automation_conditions_settings',
        keyParent: 'wallet_management',
        // name: '토큰 및 NFT 관리',
        name: '알림 설정',
        // link: '/admin/wallet/tokenNFT/automation',
        link: '/admin/wallet/automation',
        // child: [
        //   {
        //     key: 'automation_conditions_settings',
        //     name: '자동화 조건 설정',
        //     link: '/admin/wallet/tokenNFT/automation'
        //   },
        //   {
        //     key: 'xper_publish',
        //     name: 'XPER 발행',
        //     link: '/admin/wallet/tokenNFT/xperPublish'
        //   }
        // ]
      },
      {
        key: 'server_status',
        keyParent: 'wallet_management',
        name: '서버 상태 모니터링',
        link: 'https://perplay-status-web-prod.azurewebsites.net/status',
      }
    ]
  },
  {
    key: 'app_management',
    name: '앱 관리',
    multilevel: true,
    icon: 'appManagement',
    child: [
      {
        key: 'fix_app_data',
        keyParent: 'app_management',
        name: '앱 데이터 수정',
        // icon: '',
        child: [
          {
            key: 'real_time_numerical_change',
            name: '실시간 데이터 수정',
            link: '/admin/app/fixAppData/realTime'
          },
          {
            key: 'item_db',
            name: '아이템 DB 수정',
            link: '/admin/app/fixAppData/itemDB'
          },
          {
            key: 'nft',
            name: 'NFT',
            link: '/admin/app/fixAppData/nft'
          },
          {
            key: 'free_nft_code_generate',
            name: 'Free NFT 코드 생성',
            link: '/admin/app/fixAppData/freeNFTGenerate'
          }
        ]
      },
      {
        key: 'game',
        keyParent: 'app_management',
        name: '게임',
        // icon: '',
        child: [
          {
            key: 'campaign_games',
            name: '캠페인용 게임',
            link: '/admin/app/game/campaign'
          },
          {
            key: 'game_tagging',
            name: '게임 태깅',
            link: '/admin/app/game/tagging'
          },
        ]
      },
      {
        key: 'campaign',
        keyParent: 'app_management',
        name: '캠페인',
        // icon: '',
        child: [
          {
            key: 'recommended_game',
            name: '추천 게임 캠페인',
            link: '/admin/app/campaign/recommended'
          },
          {
            key: 'special_game',
            name: '스페셜 게임 캠페인',
            link: '/admin/app/campaign/special'
          }
        ]
      },
      {
        // key: 'maintenance',
        key: 'maintenance_schedule',
        keyParent: 'app_management',
        // name: '점검',
        name: '점검 일정',
        link: '/admin/app/maintenance',
        // icon: '',
        // child: [
        //   {
        //     key: 'maintenance_schedule',
        //     name: '점검 일정',
        //     link: '/admin/app/maintenance/schedule'
        //   },
        //   {
        //     key: 'maintenance_connection_ip',
        //     name: '점검 중 접속 가능 IP 관리',
        //     link: '/admin/app/maintenance/whitelist'
        //   },
        // ]
      },
    ]
  },
  {
    key: 'event_management',
    name: '이벤트 관리',
    multilevel: true,
    icon: 'eventManagement',
    child: [
      {
        key: 'operating_event',
        keyParent: 'event_management',
        name: '운영 이벤트',
        link: '/admin/event/operEvent'
      },
      {
        key: 'balance_event',
        keyParent: 'event_management',
        name: '인앱 수치 조정',
        // link: '/admin/event/operEvent',
        child: [
          {
            key: 'mining_bonus',
            name: '토큰 채굴 보너스',
            link: '/admin/event/balance/mining'
          },
          // {
          //   key: 'special_game',
          //   name: '스페셜 게임 캠페인',
          //   link: '/admin/app/campaign/special'
          // },
        ],
      },
      {
        key: 'new_user_event',
        keyParent: 'event_management',
        name: '신규 유저 확보',
        child: [
          {
            key: 'invitation',
            name: '파트너사 추천',
            link: '/admin/event/newUser/invitation'
          },
          {
            key: 'free_nft',
            name: 'FREE NFT',
            link: '/admin/event/newUser/freeNFT'
          },
        ]
      },
      {
        key: 'user_activity_event',
        keyParent: 'event_management',
        name: '인앱 활동 보상',
        child: [
          {
            key: 'starter_pack',
            name: '스타터 팩',
            link: '/admin/event/userActivity/starterPack'
          },
        ]
      },
    ]
  },
  {
    key: 'user_management',
    name: '유저 관리',
    multilevel: true,
    icon: 'userManagement',
    child: [
      {
        key: 'perplay_user_management',
        keyParent: 'user_management',
        name: '퍼플레이 유저 관리',
        link: '/admin/user/perplayUser/userInfo',
        // child: [
        //   {
        //     key: 'userInfo',
        //     name: '유저 정보',
        //     link: '/admin/user/perplayUser/userInfo',
        //   },
        //   {
        //     key: 'perplay_use_log',
        //     name: '이용 내역',
        //     link: '/admin/user/perplayUser/useLog'
        //   },
        //   {
        //     key: 'customer_inquiry',
        //     name: '고객 문의',
        //     link: '/admin/user/perplayUser/customerInquiry'
        //   }
        // ]
      },
      // {
      //   key: 'push_message',
      //   keyParent: 'user_management',
      //   name: '푸시 알림',
      //   link: '/admin/user/push'
      // },
      // {
      //   key: 'in_app_message',
      //   keyParent: 'user_management',
      //   name: '앱 진입 시 공지',
      //   link: '/admin/user/inApp'
      // },
      {
        key: 'message',
        keyParent: 'user_management',
        name: '우편',
        link: '/admin/user/message'
      },
    ]
  },
  {
    key: 'log_management',
    name: '로그 관리',
    multilevel: true,
    icon: 'logManagement',
    child: [
      {
        key: 'user',
        name: '유저 로그',
        // icon: 'polymer',
        child: [
          {
            key: 'login',
            keyParent: 'log_management',
            name: '로그인 로그',
            link: '/admin/log/user/login'
          },
          {
            key: 'session',
            keyParent: 'log_management',
            name: '세션 로그',
            link: '/admin/log/user/session'
          },
        ]
      },
      {
        key: 'perplay',
        name: '퍼플레이 로그',
        // icon: 'polymer',
        child: [
          {
            key: 'gamesession',
            keyParent: 'log_management',
            name: '게임세션 로그',
            link: '/admin/log/perplay/gamesession'
          },
          {
            key: 'specialbox',
            keyParent: 'log_management',
            name: '스페셜박스 로그',
            link: '/admin/log/perplay/specialbox'
          },
          {
            key: 'powercharge',
            keyParent: 'log_management',
            name: '파워 충전 로그',
            link: '/admin/log/perplay/powerCharge'
          },
          {
            key: 'levelup',
            keyParent: 'log_management',
            name: '파워 충전 로그',
            link: '/admin/log/perplay/levelUp'
          },
          {
            key: 'breed',
            keyParent: 'log_management',
            name: '브리드 로그',
            link: '/admin/log/perplay/breed'
          },
          {
            key: 'evolve',
            keyParent: 'log_management',
            name: '이볼브 로그',
            link: '/admin/log/perplay/evolve'
          },
          {
            key: 'wallet_transaction',
            keyParent: 'log_management',
            name: '월렛 트랜잭션 로그',
            link: '/admin/log/perplay/walletTransaction'
          },
          {
            key: 'nft_transaction',
            keyParent: 'log_management',
            name: 'NFT 트랜잭션 로그',
            link: '/admin/log/perplay/nftTransaction'
          },
          {
            key: 'inventory_transaction',
            keyParent: 'log_management',
            name: '인벤토리 트랜잭션 로그',
            link: '/admin/log/perplay/inventoryTransaction'
          },
        ]
      },
    ]
  },
  {
    key: 'monitoring',
    name: '모니터링',
    icon: 'monitoring',
    link: ''
  },
  {
    key: 'backoffice_management',
    name: '백오피스 관리',
    multilevel: true,
    icon: 'backofficeManagement',
    child: [
      {
        key: 'manager_management',
        name: '매니저 관리',
        // icon: 'polymer',
        link: '/admin/backoffice/manager'
      },
      // {
      //   key: 'partner_management',
      //   name: '파트너 관리',
      //   // icon: 'polymer',
      //   link: '/admin/backoffice/partner'
      // },
      {
        key: 'log_management',
        name: '로그 관리',
        // icon: 'polymer',
        link: '/admin/backoffice/log'
      },
      // {
      //   key: 'connection_ip_management',
      //   name: '접속 가능 IP 관리',
      //   // icon: 'polymer',
      //   link: '/admin/backoffice/connectIP'
      // },
      {
        key: 'category_management',
        name: '카테고리 관리',
        // icon: 'polymer',
        link: '/admin/backoffice/category'
      },
    ]
  },
  {
    key: 'setting',
    name: '환경 설정',
    multilevel: true,
    icon: 'setting',
    child: [
      {
        key: 'user_info_management',
        name: '내 정보 관리',
        link: '/admin/setting/userInfo'
      },
      {
        key: 'site_setting',
        name: '사이트 설정',
        link: '/admin/setting/site'
      }
    ]
  },
];
